export default "__VITE_ASSET__BGgc3CFR__"